<template lang="pug">
.activity-filters-row.date-controls(:class="{ disabled: loading, highlight: highlightChange }")
  slot
  AppDatePicker.mr-30(
    v-if="isPast"
    v-model="date"
    type="daily"
    :min-date="minDate"
    :max-date="maxDate"
    :start-date="date"
    :start-week-on="startWeekOn"
    :disable-future="isMaxDate"
  )
  AppTimeZoneDropdown(
    :class="{ past: isPastView }"
    :tooltip-options="tooltipOptions"
    :direction="timeZoneDropdownDirection"
    :options="timeZoneOptions"
    :active="activeTimeZone"
    @input="changeTimeZone"
  )
</template>

<script>
import { some, debounce } from 'lodash-es';
import { mapActions, mapGetters, mapState } from 'vuex';
import { formatInternalDate, parseInternalDate } from '~/utils/time_utils';

export default {
  name: 'ActivitiesLocationDateTZControls',
  props: {
    isPast: Boolean,
  },
  data: () => ({
    highlightChange: false,
    timeZoneDropdownDirection: 'right',
    tooltipOptions: Object.freeze({ container: 'body' }),
  }),
  computed: {
    ...mapGetters(['isPastView', 'startWeekOn', 'activeTimeZone', 'timeZoneOptions']),
    ...mapState({
      minDate: 'min_date',
      maxDate: 'max_date',
      loading: (state) => some(state.loading, (bool) => bool),
    }),
    date: {
      get() {
        return parseInternalDate(this.$store.state.date);
      },
      set(inputDate) {
        const date = formatInternalDate(parseInternalDate(inputDate));

        this.clearSelected();
        this.setDate(date);
        this.$emit('change-date');
      },
    },
    isMaxDate() {
      return this.date.isSame(this.maxDate, 'day');
    },
  },
  watch: {
    async isPastView(newValue) {
      if (newValue) {
        await this.$nextTick();

        this.highlightChange = true;

        setTimeout(() => {
          this.highlightChange = false;
        }, 800);
      }
    },
  },
  mounted() {
    this.onWindowResize = debounce(this.onWindowResize.bind(this), 150);
    window.addEventListener('resize', this.onWindowResize, false);
    this.onWindowResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize, false);
  },
  methods: {
    ...mapActions(['setDate', 'clearSelected', 'setActiveTimeZone']),
    changeTimeZone(timeZone) {
      this.clearSelected();
      this.setActiveTimeZone(timeZone);
      this.$emit('change-time-zone');
    },
    onWindowResize() {
      const direction = window.innerWidth < 568 ? 'left' : 'right';

      this.timeZoneDropdownDirection = direction;
    },
  },
};
</script>
